import { useCallback } from 'react';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { IPackagesSections } from '@bridebook/toolbox/src/map-packages-to-sections';
import { IEnrichedSupplier } from '@bridebook/toolbox/src/supplier/types';
import { Box } from '@bridebook/ui';
import PricingAccordion from '@bridebook/web/app-shared/components/supplier/sections/pricing/pricing-accordion-renderer';
// eslint-disable-next-line no-restricted-imports
import { revealedMoreContentAnalytics } from '@bridebook/web/lib/supplier/actions';
import { getVenuePricingItems } from '@bridebook/web/app-shared/lib/supplier/utils/get-venue-pricing-items';
import componentStyles from './venue-pricing.style';
import { useDispatch } from '@bridebook/web/app-shared/lib/utils';

interface IProps {
  packages: IPackagesSections | undefined;
  supplier: IEnrichedSupplier | undefined;
  onShowMore?: () => void;
  defaultCurrency: string | null;
  market: Market;
  isMobile: boolean;
}

const VenuePricing = ({ packages, supplier, market, isMobile, defaultCurrency }: IProps) => {
  const dispatch = useDispatch();

  const items = packages
    ? getVenuePricingItems({
        packages,
      })
    : [];

  const styles = componentStyles();

  const handleShowDetailsClick = useCallback(() => {
    dispatch(revealedMoreContentAnalytics('accordion', 'pricingBlockInfo'));
  }, [dispatch]);

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.itemsWrapper}>
        {items.map((item) => (
          <Box key={`venue-pricing-section-item-${item.dealType}`}>
            <PricingAccordion
              {...item}
              supplierCurrency={supplier?.l10n?.currency || defaultCurrency}
              market={market}
              isMobile={isMobile}
              onShowDetailsClick={handleShowDetailsClick}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default VenuePricing;
